import { ofetch } from 'ofetch'

export const $api = ofetch.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT || '/api',
  async onRequest({ options }) {
    const tokenKey = (import.meta.env.VITE_APP_TITLE || 'timeticket') + '-token'
    const accessToken = localStorage.getItem(tokenKey)?.replaceAll('"', '')
    
    if (accessToken) {
      options.headers = new Headers(options.headers)
      options.headers.set('Authorization', `Bearer ${accessToken}`)
    }
  },
})
